import React, { Component, useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { Formik, Field, Form } from "formik"
import fieldModel from "models/neighborhood"
import { useHistory } from "react-router-dom"
import Dropzone from "react-dropzone"
import * as Yup from "yup"
import ReactSelect from "components/ReactSelect"
import nullToEmptyString from "helpers/nullToEmptyString"
import _ from "lodash"
import Title from "../general/title"
import request from "superagent"
import matchModel from "helpers/matchModel"
import CKEditor from "@ckeditor/ckeditor5-react"
import BalloonEditor from "@ckeditor/ckeditor5-build-balloon"
import { toast } from "react-toastify"
import ColorPicker from "components/ColorPicker"
import classNames from "classnames"
import LatLngPicker from "components/LatLngPicker"
import submitDataAsync from "helpers/asyncSubmitData"
import settings from "settings"
import { GridContextProvider, GridDropZone, GridItem, swap } from "react-grid-dnd"

const EditNeighborhood = (props) => {
	const [fields, setFields] = useState(fieldModel)
	const [property, setProperty] = useState(false)
	const [images, setImages] = useState([])
	const history = useHistory()
	let id = parseInt(props.match.params.id)

	useEffect(() => {
		getProperty()
	}, [])

	useEffect(() => {
		if (props.payloadStatus) {
			let neighborhood = _.find(props.payload.public.neighborhoods, { id: id })
			neighborhood = nullToEmptyString(neighborhood)
			let f = matchModel(fields, neighborhood)
			if(f.images) setImages(f.images)
			setFields(f)
		}
	}, [props.payloadStatus, props.match.params.id])

	const getProperty = async () => {
		let property = await submitDataAsync("getProperty", {
			id: props.activeProperties[0],
		})
		setProperty(property.data)
	}

	const validationSchema = Yup.object().shape({
		name: Yup.string().required("Required"),
		property: Yup.number().required("Required"),
	})

	const submitClasses = (f) => {
		return classNames("form__submit", {
			"form__submit--ready": f,
		})
	}

	const options = (name) => {
		let opts = []
		_.forEach(props.payload.public[name], (v) => {
			opts.push({ label: v.name, value: v.id })
		})
		return opts
	}

	const compileThumbs = (f) => {
		const arrayMove = require("array-move")
		const onChange = (sourceId, sourceIndex, targetIndex) => {
			//console.log(sourceId, sourceIndex, targetIndex)
			let imgs = _.clone(images)
			imgs = arrayMove(imgs, sourceIndex, targetIndex)
			setImages(imgs)
			f.values.images = imgs
		}
		let rows = Math.ceil(images.length / 4)
		let height = rows * 220
		return (
			<GridContextProvider onChange={onChange}>
				<GridDropZone
					id="items"
					boxesPerRow={4}
					rowHeight={200}
					style={{ height: `${height}px`, width: "100%" }}>
					{images.map((item, k) => {
						let url = `${settings.s3}${item}`
						// Parantheses in filename break image thumbnail
						url = decodeURI(url) // decding first because some url's are encoded already....% then gets to %25.
						url = encodeURI(url)
						url = url.replace(/\(/g, "%28").replace(/\)/g, "%29")
						let icon = (
							<div
								className="imageZone__thumb"
								key={`thumb` + item}
								style={{
									backgroundImage: `url(${url})`,
								}}>
								<i
									className="fas fa-times-circle formFiles__removeIcon"
									onClick={() => removeImage(k, f)}></i>
							</div>
						)
						return (
							<GridItem key={item} className="imageZone__block">
								<div
									style={{
										width: "100%",
										height: "100%",
										paddingBottom: "20px",
										paddingRight: "20px",
									}}>
									{icon}
								</div>
							</GridItem>
						)
					})}
				</GridDropZone>
			</GridContextProvider>
		)
	}

	const removeImage = (k, f) => {
		let imgs = _.clone(images)
		imgs.splice(k, 1)
		setImages(imgs)
		f.setFieldValue("images", imgs)
		let values = {
			images: imgs,
			type: "neighborhood",
			id,
		}
		submitData("removeImage", values).then((data) => {
			toast.success(data.message)
		})
	}

	const onImageDrop = (files, f) => {
		const req = request.post(`${settings.ep}/inputNeighborhoodImages`)
		_.forEach(files, (r, k) => {
			req.attach(r.name, files[k])
		})
		//req.attach(files[0].name, files[0])
		req.set("Authorization", `Bearer ${localStorage.user}`)
		req.field(
			"attributes",
			JSON.stringify({
				id,
			})
		)
		req.end((err, response) => {
			//return
			try {
				let resp = response.body

				if (err) {
					console.log(err)
				}
				if (resp.status == 200) {
					let imgs = _.cloneDeep(images)
					imgs = resp.data
					f.setFieldValue("images", resp.data)

					setImages(imgs)
					console.log(imgs)
				}
			} catch (e) {
				console.error(e)
			}
		})
	}

	let lookup = _.find(props.payload.public.neighborhoods, { id })
	let coords = lookup ? lookup.map_text_coords : null

	if (!props.payloadStatus || !property) {
		return ""
	} else {
		return (
			<div>
				<Title title="Edit Neighborhood" showDate={false} />
				<div className="content">
					<h3 />
					<Formik
						enableReinitialize
						validateOnMount={true}
						initialValues={fields}
						validationSchema={validationSchema}
						onSubmit={(values) => {
							props.loadingStatus(true)
							if (values.lat || values.lng) {
								values.map_text_coords = JSON.stringify([values.lng, values.lat])
								delete values.lat
								delete values.lng
							}
							if (!values.map_text_coords || _.isEmpty(values.map_text_coords))
								delete values.map_text_coords
							submitData("updateNeighborhood", values).then((data) => {
								props.loadingStatus(false)
								toast.success(data.message)
								history.push("/admin/neighborhoods")
								props.getPayload()
							})
						}}>
						{(f) => (
							<div className="editCommunity">
								{/* console.log(f.values) */}
								<Form>
									<ul className="form__list">
										<li className={fieldStatus("name", f)}>
											<label htmlFor="name">
												Name <sup>*</sup>
											</label>
											{f.errors.name && f.touched.name && (
												<div className="form__message">{f.errors.name}</div>
											)}
											<Field name="name" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("property", f)}>
											<label htmlFor="property">
												Property <sup>*</sup>
											</label>
											{f.errors.property && f.touched.property && (
												<div className="form__message">{f.errors.property}</div>
											)}
											<ReactSelect
												name={`property`}
												options={_.map(props.payload.public.properties, (v) => {
													return { label: v.name, value: v.id }
												})}
												value={f.values.property}
												onBlur={f.setFieldTouched}
												onChange={f.setFieldValue}
											/>
										</li>
										<li className={fieldStatus("details", f)}>
											<label htmlFor="details">Details</label>
											{f.errors.details && f.touched.details && (
												<div className="form__message">{f.errors.details}</div>
											)}
											<Field name="details" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("subdivision", f)}>
											<label htmlFor="subdivision">Subdivision</label>
											{f.errors.subdivision && f.touched.subdivision && (
												<div className="form__message">{f.errors.subdivision}</div>
											)}
											<ReactSelect
												name={`subdivision`}
												options={options("subdivisions")}
												value={f.values.subdivision}
												onBlur={f.setFieldTouched}
												onChange={f.setFieldValue}
											/>
										</li>
										<li className={fieldStatus("description", f)}>
											<label htmlFor="description">Description</label>
											{f.errors.description && f.touched.description && (
												<div className="form__message">{f.errors.description}</div>
											)}
											<CKEditor
												editor={BalloonEditor}
												data={f.values.description}
												onInit={(editor) => {
													editor.setData(f.values.description)
												}}
												onChange={(event, editor) => {
													const data = editor.getData()
													f.setFieldValue("description", data)
												}}
												onBlur={() => {
													f.setFieldTouched("description")
												}}
											/>
										</li>
										<li className={fieldStatus("from_the", f)}>
											<label htmlFor="from_the">From the</label>
											{f.errors.name && f.touched.name && (
												<div className="form__message">{f.errors.from_the}</div>
											)}
											<Field name="from_the" type="text" className="form__input" />
										</li>
										<li className={fieldStatus("color", f)}>
											<label htmlFor="color">
												Color{" "}
												<span className="small">
													<i className={`fas fa-info-circle`} style={{ marginRight: 5 }} />
													Hex Code
												</span>
											</label>
											{f.errors.color && f.touched.color && (
												<div className="form__message">{f.errors.color}</div>
											)}
											<Field name="color" type="text" className="form__input" />
											<ColorPicker
												name={`color`}
												value={f.values.color}
												onChange={(v) => f.setFieldValue("color", v)}
											/>
										</li>
									</ul>
									<h3>Neighborhood Imagery</h3>
									<div className="imageZone py-4">
										<Dropzone
											multiple={true}
											onDrop={(files) => {
												onImageDrop(files, f)
											}}>
											{({ getRootProps, getInputProps }) => (
												<section className="dropzone">
													<div {...getRootProps()} className="dropbox__cont imageZone__cont">
														<input {...getInputProps()} />
														<p className="dropzone__action imageZone__action">
															Drag 'n' drop images here, or click to select images.
														</p>
													</div>
												</section>
											)}
										</Dropzone>
										<div className="imageZone__existing">
											<ul className="imageZone__list">{compileThumbs(f)}</ul>
										</div>
									</div>
									<div className="mb-8">
										<h3>Map Text Location</h3>
										<LatLngPicker
											height={400}
											formik={f}
											{...props}
											coords={coords}
											property={property}
										/>
									</div>
									<input type="submit" value="Submit" className={submitClasses(f.isValid)} />
								</Form>
							</div>
						)}
					</Formik>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPayload,
			loadingStatus,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(EditNeighborhood)
